import type { AssetProcessingActivityReviewRow } from 'config/api/ropaReviews/ropaReviews.types';

export type DpiaAdminRowActionContext = Pick<AssetProcessingActivityReviewRow, 'dpiaDisplayStatus' | 'dpiaRequestStatus' | 'dpiaId'>;

export const canShowDpiaHistoryAction = (row: Pick<AssetProcessingActivityReviewRow, 'hasPreviousDpias' | 'dpiaCount'>): boolean =>
  Boolean(row.hasPreviousDpias || (row.dpiaCount ?? 0) > 1);

export const canStartDpiaReassessment = (status: string | undefined, canEdit = true): boolean => canEdit && status === 'decision_made';

export const isDpiaRequestAwaitingRaAssessment = (ctx: DpiaAdminRowActionContext): boolean => ctx.dpiaRequestStatus === 'draft';

export const isDpiaFormAwaitingAdminReview = (ctx: DpiaAdminRowActionContext): boolean =>
  ['ready_for_review', 'clarification_requested'].includes(ctx.dpiaDisplayStatus);

export const shouldShowApaReviewRowActions = (ctx: DpiaAdminRowActionContext): boolean =>
  !isDpiaRequestAwaitingRaAssessment(ctx) && !isDpiaFormAwaitingAdminReview(ctx);

export const shouldShowOpenAdminDpiaReview = (ctx: DpiaAdminRowActionContext): boolean =>
  Boolean(ctx.dpiaId) && isDpiaFormAwaitingAdminReview(ctx);

export const getAdminDpiaNeedAssessmentAction = (ctx: DpiaAdminRowActionContext, canAssessDpia: boolean): 'reassess' | 'assess' | null => {
  if (!canAssessDpia) {
    return null;
  }

  if (isDpiaFormAwaitingAdminReview(ctx)) {
    return null;
  }

  if (ctx.dpiaDisplayStatus === 'decision_made') {
    return 'reassess';
  }

  if (isDpiaRequestAwaitingRaAssessment(ctx)) {
    return 'assess';
  }

  if (['indicated', 'dpia_required'].includes(ctx.dpiaDisplayStatus)) {
    return 'assess';
  }

  return null;
};
